import type { NormalizedPoint } from '../model';

export interface PaperSize {
  readonly width: number;
  readonly height: number;
}

export function clamp01(value: number): number {
  return Math.min(1, Math.max(0, value));
}

export function roundToOneDecimal(value: number): number {
  return Math.round(value * 10) / 10;
}

export function clientToNormalizedPoint(clientX: number, clientY: number, rect: DOMRect): NormalizedPoint {
  if (rect.width <= 0 || rect.height <= 0) {
    return { x: 0, y: 0 };
  }

  return {
    x: clamp01((clientX - rect.left) / rect.width),
    y: clamp01((clientY - rect.top) / rect.height)
  };
}
